<template>
  <div class="container tw-flex tw-flex-col tw-items-center type-client">
    <title-section
    title="Tipo"
    subtitle="Tipo de vivienda"></title-section>
    <div class="mdc-chip-set mdc-chip-set--choice justify-center tw-mt-8 tw-flex tw-flex-col">
      <div class="tw-flex lg:tw-flex-row tw-flex-col">
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('piso')}" @click="selectChip('piso')" role="row">
          <div class="mdc-chip__ripple"></div>
          <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
              <span class="mdc-chip__text">Piso</span>
            </span>
          </span>
          <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
          </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('casa')}" @click="selectChip('casa')" role="row">
          <div class="mdc-chip__ripple"></div>
          <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
              <span class="mdc-chip__text">Casa</span>
            </span>
          </span>
          <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
          </span>
        </div> 
      </div>
      <div class="tw-flex lg:tw-flex-row tw-flex-col">
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('local')}" @click="selectChip('local')" role="row">
          <div class="mdc-chip__ripple"></div>
          <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
              <span class="mdc-chip__text">Local</span>
            </span>
          </span>
          <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
          </span>
        </div>
        <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('otro')}" @click="selectChip('otro')" role="row">
          <div class="mdc-chip__ripple"></div>
          <span role="gridcell">
            <span role="button" tabindex="0" class="mdc-chip__primary-action">
              <span class="mdc-chip__text">Otro</span>
            </span>
          </span>
          <span role="gridcell">
            <i class="material-icons mdc-chip__icon" role="button">done</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { initiateChips } from "../../utils";
import { mapMutations, mapGetters } from "vuex";
export default {
  computed: {
      ...mapGetters({
          wizard: 'getWizard'
      })
  },
  methods: {
    ...mapMutations(["selectTypeApartment","selectDirection"]),
    selectChip(chip) {
      if(this.$cookies.get("directionValue") && this.wizard.direction == ''){
        this.selectDirection(this.$cookies.get("directionValue"));
      }
      this.selectTypeApartment(chip);
      this.$cookies.set("directionValue", this.wizard.direction , "1d");
      this.$router.push({ name: "Size" });
    },
    isSelected(chip){
        return chip === this.wizard.typeApartment;
    }
  },
  mounted() {
    initiateChips();
  }
};
</script>

<style lang="scss">
@import "../../../sass/variables";
.type-client {
  .mdc-chip {
    width: 319.4px;
    height: 58.7px;
    @media(max-width: $lg){
      width: 100%;
    }
  }
}
</style>
